import { useSelector } from 'react-redux';

import { registrationStatusSelector } from '../services/selectors';

export const useRegistrationStatus = () => useSelector(registrationStatusSelector);
